module.exports = __webpack_public_path__ + "static/img/kanban04.63801067.png";